import React from "react";

import { ReactComponent as PlusWhiteIcon } from "src/images/plus-white.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import NotFoundImg from "src/images/clickbait.svg";
import { EmptyTabContainer } from "./EmptyTabContainer/EmptyTabContainer";
import { EmptyTabContent } from "./EmptyTabContent/EmptyTabContent";

function EmptyPaymentsTab(props) {
  const { taskType, onButtonClick } = props;

  const renderText = () => {
    switch (taskType) {
      case "creator":
        return (
          <IDHFormattedMessage
            id="ws_empty_payments_tab_creator_text"
            defaultMessage="No payments has been assigned to this creator. \n Add new or assign already added payment."
          />
        );
      case "content":
        return (
          <IDHFormattedMessage
            id="ws_empty_payments_tab_content_text"
            defaultMessage="No payments has been assigned to this content. \n Add new or assign already added payment."
          />
        );
    }
  };

  return (
    <EmptyTabContainer className="empty-actions-tab">
      <EmptyTabContent
        text={renderText()}
        buttonText={
          <IDHFormattedMessage
            id="ws_add_payment"
            defaultMessage="Add payment"
          />
        }
        onButtonClick={onButtonClick}
        buttonIcon={<PlusWhiteIcon />}
        imgUrl={NotFoundImg}
      />
    </EmptyTabContainer>
  );
}

export { EmptyPaymentsTab };
